import {IntermediatePart} from "../../parts/intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {Shower} from "../../parts/shower";
import {LayoutAbbreviation} from "../../constants";
import {getMetadataByDimensions, iIncludes} from "../../../../../misc/utils";

export default class ExternallWall extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.visible = true;
    this.activeFeatureBeforeAllWalls = null;
    this.selectedByUser = false;
    this.allWallsApplied = false;
    this.isStoneFeature = true;
  }

  navigationSubItems(filters, searchText) {
    const featuresToDisplay = super.getFeaturesBySearchText(this.getAvailableFeatures(filters), searchText);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  getAvailableFeatures(filters) {
    const conditions = this.getArrayOfConditions();
    // console.log('condtitions', condtitions);
    const filteredAvailableFeatures = super.getFilteredFeaturesByFilters(filters);
    return super.navigationSubItemsWithFilterMultipleConditions(conditions, filteredAvailableFeatures);
  }

  setLayers(layout) {
    // this.wallName === "ExtrusionWallLeft" && console.log('this.getArrayOfConditions()', this.getArrayOfConditions());
    const shower = layout.parts[Shower.id];
    const wallParent = this.getParent();
    const conditions = this.getArrayOfConditions();
    // const layoutAbr = layout.getCurrentLayoutAbbreviation();
    if (this.activeFeature) {
      if (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature) {
        super.setLayers(layout)
      } else if (shower.isComplete()) {
        if (this.wallName === "ExtrusionWallLeft" || !shower.showerBody.activeFeature.partName.includes("Complete")) {
          super.hideLayers();
          return;
        } else if (this.activeFeature && !this.activeFeature.matchesMetaForArrayOfConditions(conditions)) {
          this.setDefault(layout) // set new default layer
        }
      } else if (!this.activeFeature.matchesMetaForArrayOfConditions(conditions)) {
        this.setDefault(layout) // set new default layer
      }
      if (this.wallName === "ExtrusionWallLeft") {
        const activeShower = wallParent.getActiveShowerGroup();
        const showerDimensions = activeShower.showerDimensions();
        if (showerDimensions === "Pony") {
          super.hideLayers();
          return;
        }
        if (!shower.isComplete()) {
          this.setShadowFeature();
        }
      }
    }
    if (this.shadowFeature) {
      const layoutAbr = layout.getCurrentLayoutAbbreviation();
      const matchesByBindings = this.shadowFeature.dbFeature.s3Bindings.some(binding => {
        return binding.layout === LayoutAbbreviation.All || binding.layout === layoutAbr
      });
      if (!this.shadowFeature.matchesMetaForArrayOfConditions(this.getShadowConditions()) || !matchesByBindings) {
        this.setShadowFeature();
      }
    }
    super.setLayers(layout)
  }

  setDefault(layout) {
    const layoutAbr = layout.getCurrentLayoutAbbreviation();
    const shower = layout.parts[Shower.id];
    if (!shower) {
      console.log('Ex Wall - no Shower');
      return null;
    }
    if (layoutAbr === LayoutAbbreviation.Large) {
      if ((shower.isComplete() && this.wallName === "ExtrusionWallLeft")
        || !shower.showerBody || !shower.showerBody.activeFeature
        || (shower.isComplete() && !shower.showerBody.activeFeature.partName.includes("Complete"))) {
        return null;
      }
    }
    const filteredFeatures = this.getAvailableFeatures();
    // console.log('Ex Wall - setDefault', filteredFeatures);
    if (!super.tryToSetTheSameFeature(filteredFeatures, null, null, true)) {
      let hardCodedName = '';
      switch (layoutAbr) {
        case LayoutAbbreviation.Small:
          hardCodedName = 'Rafter';
          break;
        case LayoutAbbreviation.Large:
          hardCodedName = 'Sahara Autumn  Porcelain Tile';
          break;
      }
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return iIncludes(feature.dbFeature.displayName, hardCodedName);
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return iIncludes(feature.dbFeature.displayName, " - placeholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault;
      this.setShadowFeature();
    }
  }

  setZIndex(zIndexes) {

    const shower = zIndexes.Shower;
    const wallParent = this.getParent();

    if (zIndexes && this.wallName === "ExtrusionWallLeft") {
      // console.warn(`${this.wallName}: no wall, because we have a complete shower.`);
      if (wallParent.layout.parts[Shower.id].isComplete()) {
        return false;
      } else if (this.activeFeature) {
        const activeShowerGroup = wallParent.getActiveShowerGroup();
        const showerDimensions = getMetadataByDimensions(activeShowerGroup.showerDimensions());
        const zIndex = showerDimensions === "Half"
          ? shower.Custom60in[this.wallName + "HalfWall"]
          : shower.Custom60in[this.wallName];
        const zIndexShadow = showerDimensions === "Half"
          ? shower.Custom60in[this.wallName + "ShadowHalfWall"]
          : shower.Custom60in[this.wallName + "Shadow"];
        this.activeFeature.layer.zIndex = zIndex;
        if (this.placeholderFeature) {
          this.placeholderFeature.layer.zIndex = zIndex;
        }
        if (this.shadowFeature) {
          this.shadowFeature.layer.zIndex = zIndexShadow;
        }
      }
    } else {
      if (zIndexes && this.activeFeature) {
        this.activeFeature.layer.zIndex = shower.Custom60in[this.wallName];
      }
      if (zIndexes && this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = shower.Custom60in[this.wallName];
      }
      if (zIndexes && this.shadowFeature) {
        this.shadowFeature.layer.zIndex = shower.Custom60in[this.wallName + "Shadow"];
      }
    }
  }

  clickFromAllWalls(ignoreLocked) {
    if (!this.getParent().selectedByUser) {
      this.handleClick(ignoreLocked, 'all_walls')
    }
  }

  handleClick(ignoreLocked, clickFrom) {
    const parent = this.getParent();
    if (!parent.getParent().allWallsApplied && clickFrom !== 'all_walls') {
      parent.selectedByUser = true;
    }
    if (clickFrom !== 'context' && clickFrom !== 'all_walls') {
      const wallParent = this.getParent().getParent();
      const ponyWallFeature = wallParent.ponyWall && wallParent.ponyWall.features.find(feature => {
        return feature.partName === this.partName
      });
      if (ponyWallFeature) {
        ponyWallFeature.handleClick(ignoreLocked, 'context');
      }
    }
    super.handleClick(ignoreLocked);

    // if (parent.wallName === "ExtrusionWallLeft") {
    //   const wallB = parent.getParent().layout.parts["Walls"].part["wallB"];
    //   if (wallB.placeholderChanged && wallB.activeFeature.partName === this.partName) {
    //     parent.selectedByUser = false;
    //   }
    // } else {
    //   const wallC = parent.getParent().layout.parts["Walls"].part["wallC"];
    //   if (wallC.placeholderChanged && wallC.activeFeature.partName === this.partName) {
    //     parent.selectedByUser = false;
    //   }
    // }
  }

  // unCheckAllWalls(clickFrom) {
  //   if (clickFrom === 'showerWall') {
  //     this.allWallsApplied = false;
  //   }
  //   const tempSelectedByUser = this.selectedByUser;
  //   if (this.activeFeatureBeforeAllWalls) {
  //     this.activeFeatureBeforeAllWalls.handleClick();
  //     this.activeFeatureBeforeAllWalls = null;
  //   }
  //   this.selectedByUser = tempSelectedByUser;
  //   if (this.rememberToRecoverPlaceholder) {
  //     this.placeholderChanged = false;
  //     this.rememberToRecoverPlaceholder = false;
  //   }
  // }
}
